import React from 'react';
import './Login.css'
import { useDispatch } from 'react-redux'
import { setId } from 'store/features/userInfo'

import db from 'service/db'

function Login(props) {

    const dispatch = useDispatch()

    function login(e) {
        let inputId = e.target.id.value
        let inputPw = e.target.pw.value
        db.login(inputId, inputPw).then(item => {
            dispatch(setId(inputId))
        }).catch(error => {
            alert('회원 정보가 없습니다.')
        })
        e.preventDefault();
    }

    return (
        <div className="container my-5" style={{ display: "flex", justifyContent: 'center' }}>
            <form className="Auth-form" onSubmit={login}>
                <div className="Auth-form-content">
                    <h3 className="Auth-form-title">Login</h3>
                    <div className="form-group mt-3">
                        <input
                            type="text"
                            className="form-control mt-1"
                            name="id"
                            placeholder="ID"
                        />
                    </div>
                    <div className="form-group mt-3">
                        <input
                            type="password"
                            className="form-control mt-1"
                            name="pw"
                            placeholder="Password"
                        />
                    </div>
                    <div className="d-grid gap-2 mt-3">
                        <button type="submit" className="btn btn-primary">
                            Submit
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default Login;